<template>
  <div>
    <el-dialog
      title="提示"
      :fullscreen="type == 'h5' ? true : false"
      :visible.sync="isShow"
      width="720px"
      :before-close="handleClose"
      :custom-class="type == 'h5' ? 'codeH5Dialog' : 'codeDialog'"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <div class="dialog-body">
        <div class="d-header">
          <div class="left">短链举报</div>
          <fm-button
            type="info"
            size="mini"
            text
            icon="icon-model-close"
            @click="handleClose"
          ></fm-button>
        </div>
        <div class="d-content" ref="scrollContainer">
          <!-- 类型 -->
          <div class="reportBox">
            <div class="label"><span class="red">*</span>类型</div>
            <el-select
              ref="mySelect"
              class="oneInput"
              placeholder="请选择原因"
              v-model="form.report_type"
            >
              <el-option
                v-for="item in typeList"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>

          <!-- 标题 -->
          <div class="reportBox">
            <div class="label"><span class="red">*</span>标题</div>
            <el-input
              class="oneInput"
              v-model="form.title"
              placeholder="请输入标题（30字以内）"
              clearable
              maxlength="30"
            >
            </el-input>
          </div>

          <!-- 详细描述 -->
          <div class="reportBox">
            <div class="label"><span class="red">*</span>详细描述</div>
            <el-input
              class="threeInput"
              v-model="form.report_reason"
              type="textarea"
              placeholder="请输入详细描述"
              resize="none"
              maxlength="2000"
              show-word-limit
            >
            </el-input>
          </div>

          <!-- 附件 -->
          <div class="reportTwoBox">
            <div class="right">
              <span class="font1">附件</span>
              <span class="font2"
                >最多上传{{ limit }}个{{
                  ext.join('、')
                }}文件，且单个文件不超过{{ maxText }}</span
              >
            </div>
            <svg-btn
              v-if="fileList.length >= limit"
              class="icon2"
              @click="handleUploadClick"
              icon-class="icon-reports-no"
            />
            <el-upload
              v-else
              class="upload"
              ref="upload-demo"
              action=""
              multiple
              :limit="limit"
              :on-exceed="exceed"
              :before-upload="verify"
              :file-list="fileList"
              :show-file-list="false"
              :http-request="upload"
            >
              <svg-btn class="icon" icon-class="icon-reports" />
            </el-upload>
          </div>
          <FileList
            ref="file"
            v-if="fileList.length > 0"
            :file-list="fileList"
          />
        </div>
        <div
          :class="{
            'd-footer': true,
            'd-footer2': fileList.length > 0,
          }"
        >
          <fm-button
            :disabled="isDisabled"
            @click="submitForm"
            type="primary"
            size="small"
            >确 定</fm-button
          >
          <fm-button @click="handleClose" type="info" plain size="small"
            >取 消</fm-button
          >
        </div>
      </div>
    </el-dialog>
    <TitleDialog
      :is-show="show"
      text="关闭弹窗内容不会保存，请确认关闭吗？"
      confirm="确 认"
      @handleClose="show = false"
      @handleConfirm="onConfirm"
    >
    </TitleDialog>
  </div>
</template>

<script>
import Upload from './Upload.vue'
import FileList from './FileList'
import TitleDialog from '@/components/Dialog/TitleDialog.vue'
import { reportGeneralAPI, getReasonAPI } from '@/axios/home'
export default {
  mixins: [Upload],
  name: 'reportDialog',
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    fshort: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'pc',
    },
  },
  components: {
    FileList,
    TitleDialog,
  },
  data() {
    return {
      form: {
        report_type: '', //举报类型
        report_source: 2, //1文件举报 2是短链举报
        title: '', //标题
        report_reason: '', //举报理由
      },
      typeList: [],
      ext: ['jpg', 'png', 'heic', 'mp4'],
      limit: 5,
      maxSize: '10M',
      maxText: '10M',
      fileList: [],
      show: false,
    }
  },
  mounted() {},
  computed: {
    isDisabled() {
      // 检查所有字段是否都有非空且非全空格的内容
      const isFormValid = Object.entries(this.form).every(([key, value]) => {
        if (typeof value === 'string') {
          // 检查是否为空或全空格
          if (!value.trim()) return false
        }
        return true
      })

      // 如果表单无效，则禁用按钮
      return !isFormValid
    },
  },
  mounted() {
    this.getReason()
  },
  methods: {
    //获取类型
    getReason() {
      //report_source 1-文件举报 2-短链举报
      getReasonAPI({ report_source: 2 }).then(res => {
        if (res.status == 1) {
          this.typeList = res.data.reason
          this.ext = res.data.upload_config.ext.map(suffix =>
            suffix.toLowerCase()
          )
          this.limit = Number(res.data.upload_config.upload_limit || 0)
          this.maxSize = Number(res.data.upload_config.max_size || 0)
          this.maxText = res.data.upload_config.max_size_format
        }
      })
    },
    transformData(data) {
      return data.map(item => {
        const node = {
          value: item.fullname || item.name,
          label: item.fullname || item.name,
        }
        if (item.children && item.children.length > 0) {
          node.children = this.transformData(item.children) // 递归处理子节点
        }
        return node
      })
    },
    //选择举报类型
    checkType(row) {
      this.form.report_type = row.id
    },
    //清除表单数据
    reset() {
      this.form = {
        report_type: '', //举报类型
        title: '', //标题
        report_reason: '', //举报理由
        report_source: 2, //1文件举报 2是短链举报
      }
      this.$nextTick(() => {
        this.$refs.mySelect.blur()
      })
      this.fileList = []
    },
    //提交方法
    submitForm: _.debounce(
      async function () {
        if (this.isDisabled) return
        if (this.fileList.some(item => item.status == 'uploading'))
          return this.$message({
            type: 'warning',
            message: '附件正在上传中，请稍后',
            customClass: 'warning',
          })
        // 提交前去掉所有字段的前后空格
        let data = this.trimFormData(this.form)
        let formData = {
          ...data,
          fshort: this.fshort,
        }
        let url = []
        if (this.fileList.length > 0) {
          this.fileList.forEach(item => {
            url.push(item.path)
          })
          formData.attachment_url = url.join(',')
        }
        let res = await reportGeneralAPI(formData)
        if (res.status == 1) {
          if (this.type == 'pc') {
            this.$toast(res.msg, 1)
          } else {
            this.$htoast(res.msg)
          }
          this.reset()
          this.$emit('handleClose')
        } else {
          if (this.type == 'pc') {
            this.$toast(res.msg, 2)
          } else {
            this.$htoast(res.msg)
          }
        }
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    //去掉数据的前后空格
    trimFormData(form) {
      return Object.keys(form).reduce((acc, key) => {
        const value = form[key]
        // 特殊处理 address 字段
        if (typeof value === 'string') {
          // 去掉字符串字段的前后空格
          acc[key] = value.trim()
        } else {
          // 其他字段保持不变
          acc[key] = value
        }
        return acc
      }, {})
    },
    handleUploadClick() {
      this.exceed()
    },
    verify(file) {
      if (file.size > this.maxSize) {
        setTimeout(
          () =>
            this.$message({
              type: 'warning',
              message: '上传文件大小超过限制',
              customClass: 'warning',
            }),
          0
        )
        return false
      } else if (
        !this.ext.some(suffix => file.name.toLowerCase().endsWith('.' + suffix))
      ) {
        setTimeout(
          () =>
            this.$message({
              type: 'warning',
              message: '上传文件扩展名是不允许的扩展名',
              customClass: 'warning',
            }),
          0
        )
        return false
      }
    },
    exceed() {
      this.$message({
        type: 'warning',
        message: `附件数量最大支持上传${this.limit}个`,
        customClass: 'warning',
      })
    },
    async upload({ file }) {
      this.isChange = true
      const item = {
        file_origin_name: file.name,
        file_size: file.size,
        status: 'uploading',
        path: null,
      }
      this.fileList.push(item)
      this.$nextTick(() => {
        this.scrollToBottom()
      })
      const result = await this.asyncUpload(file, 18)
      if (result.action === 'success') {
        item.path = result.res.data.path
        item.status = 'success'
      } else {
        item.status = 'fail'
        if (this.type == 'pc') {
          this.$toast(result.msg || '上传失败')
        } else {
          this.$htoast(result.msg || '上传失败')
        }
      }
    },
    scrollToBottom() {
      // 获取滚动容器的DOM元素
      const container = this.$refs.scrollContainer
      if (container) {
        container.scrollTop = container.scrollHeight - container.clientHeight
      }
    },
    isVideo(val) {
      return [
        /.mp4$/i,
        /.flv$/i,
        /.f4v$/i,
        /.webm$/i,
        /.m4v$/i,
        /.mov$/i,
        /.3gp$/i,
        /.3g2$/i,
        /.rm$/i,
        /rmvb$/i,
        /.wmv$/i,
        /.avi$/i,
        /.asf$/i,
        /.mpg$/i,
        /.mpeg$/i,
        /.mpe$/i,
        /.div$/i,
        /.dv$/i,
        /.divx$/i,
        /.vob$/i,
        /.dat$/i,
        /.mkv$/i,
        /.lavf$/i,
        /.cpk$/i,
        /.dirac$/i,
        /.ram$/i,
        /.qt$/i,
        /.fli$/i,
        /.flc$/i,
        /.mod$/,
      ].some(suffix => suffix.test(val))
    },
    handleClose() {
      if (
        this.form.report_type != '' ||
        this.form.title != '' ||
        this.form.report_reason != '' ||
        this.fileList.length > 0
      ) {
        this.show = true
        return
      }
      this.reset()
      this.$emit('handleClose')
    },
    onConfirm() {
      this.show = false
      this.reset()
      this.$emit('handleClose')
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .codeDialog {
  max-width: 580px;
  .el-dialog__body {
    padding: 20px 0 24px 0;
  }
  .left {
    height: 24px;
    font-weight: 500;
    font-size: 16px;
    color: #2c2c2c;
    line-height: 24px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
  .d-header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 24px 12px 24px;
    box-shadow: inset 0px -1px 0px 0px #f6f6f6;
  }
  .d-content {
    margin-top: 12px;
    padding: 0 24px;
    max-height: 640px;
    overflow-y: auto;
    box-sizing: border-box;
    -webkit-overflow-scrolling: touch;
    .reportBox {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-bottom: 24px;
      .label {
        display: flex;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 8px;
        color: #2c2c2c;
        .red {
          color: #f53f3f;
        }
      }
      .oneInput {
        width: 100%;
      }
      .twoInput {
        width: 100%;
        margin-top: 12px;
      }
      .threeInput {
        width: 100%;
        height: 184px;
        .el-textarea__inner {
          padding: 10px 12px;
          height: 184px;
        }
        .el-input__count {
          font-weight: 400;
          font-size: 14px;
          color: #8a8b92;
          line-height: 22px;
        }
      }
      .typeBox {
        display: flex;
        white-space: nowrap;
        .type {
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          margin-right: 52px;
        }
        .icon {
          width: 16px;
          height: 16px;
        }
        .font {
          font-weight: 400;
          font-size: 14px;
          line-height: 22px;
          color: #2c2c2c;
          margin-left: 8px;
        }
      }
    }
    .reportTwoBox {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 24px;
      .right {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-right: 16px;
        .font1 {
          font-weight: 400;
          font-size: 16px;
          color: #2c2c2c;
          line-height: 24px;
          margin-bottom: 4px;
        }
        .font2 {
          font-weight: 400;
          font-size: 14px;
          color: #bdbdbe;
          line-height: 22px;
        }
      }
      .upload {
        display: flex;
        align-items: center;
        height: 36px;
        .el-upload{
          height: 100%;
        }
        .el-upload__tip {
          margin-top: 0;
        }
        .icon {
          width: 36px;
          height: 36px;
          cursor: pointer;
        }
      }
      .icon2 {
        width: 36px;
        height: 36px;
        cursor: no-drop !important;
      }
    }
  }
  .d-content::-webkit-scrollbar {
    display: block;
    width: 7px;
    height: 1px;
  }

  .d-content::-webkit-scrollbar-track {
    border-radius: 10px;
    background: transparent;
  }

  .d-content::-webkit-scrollbar-thumb {
    background: rgba(217, 217, 217, 0.92);
    -webkit-box-shadow: none;
    border-radius: 4px;
  }
  .d-footer {
    padding: 0 24px;
  }
  .d-footer2 {
    padding-top: 10px !important;
  }
}
::v-deep .codeH5Dialog {
  border-radius: 0 !important;
  .el-dialog__body {
    border-radius: 0 !important;
    padding: 20px 0 24px 0;
  }
  .left {
    height: 24px;
    font-weight: 500;
    font-size: 16px;
    color: #2c2c2c;
    line-height: 24px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
  .d-header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 24px 12px 24px;
    box-shadow: inset 0px -1px 0px 0px #f6f6f6;
  }
  .d-content {
    max-height: 640px;
    overflow-y: auto;
    margin-top: 12px;
    box-sizing: border-box;
    -webkit-overflow-scrolling: touch;
    padding: 0 24px;
    .reportBox {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-bottom: 24px;
      .label {
        display: flex;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 8px;
        color: #2c2c2c;
        .red {
          color: #f53f3f;
        }
      }
      .oneInput {
        width: 100%;
      }
      .twoInput {
        width: 100%;
        margin-top: 12px;
      }
      .threeInput {
        width: 100%;
        height: 184px;
        .el-textarea__inner {
          padding: 10px 12px;
          height: 184px;
        }
        .el-input__count {
          font-weight: 400;
          font-size: 14px;
          color: #8a8b92;
          line-height: 22px;
        }
      }
      .typeBox {
        display: flex;
        white-space: nowrap;
        .type {
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          margin-right: 52px;
        }
        .icon {
          width: 16px;
          height: 16px;
        }
        .font {
          font-weight: 400;
          font-size: 14px;
          line-height: 22px;
          color: #2c2c2c;
          margin-left: 8px;
        }
      }
    }
    .reportTwoBox {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 24px;
      .right {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-right: 16px;
        .font1 {
          font-weight: 400;
          font-size: 16px;
          color: #2c2c2c;
          line-height: 24px;
          margin-bottom: 4px;
        }
        .font2 {
          font-weight: 400;
          font-size: 14px;
          color: #bdbdbe;
          line-height: 22px;
        }
      }
      .upload {
        display: flex;
        align-items: center;
        .el-upload__tip {
          margin-top: 0;
        }
        .icon {
          width: 36px;
          height: 36px;
          cursor: pointer;
        }
      }
      .icon2 {
        width: 36px;
        height: 36px;
        cursor: no-drop !important;
      }
    }
  }
  .d-content::-webkit-scrollbar {
    display: block;
    width: 7px;
    height: 1px;
  }

  .d-content::-webkit-scrollbar-track {
    border-radius: 10px;
    background: transparent;
  }

  .d-content::-webkit-scrollbar-thumb {
    background: rgba(217, 217, 217, 0.92);
    -webkit-box-shadow: none;
    border-radius: 4px;
  }
  .d-footer {
    padding: 24px 24px 0 24px;
  }
}
</style>
